module.exports = "/packs/media/images/icons/studentdebt-21d2d1e93c42f7a221bf1d0a49a79cbb.png";